import React from "react";
import { RCCModal, RCCRefModalProps } from "react-common-components";
import { useTranslation } from "src/context/Translations/context";
import { IModal, ITypeModal } from "./interface";

const Modal: React.ForwardRefRenderFunction<RCCRefModalProps, IModal> = ({children, type,...rest}, ref) => {
	const { translate } = useTranslation();

	const restX = rest;

	if(type){

		switch (type) {
		case ITypeModal.ADD: 
			restX.header = {
				...rest.header,
				icon: {
					name: "plus"
				}
			};

			restX.footer = {
				...rest.footer,
				showSaveButton: true,
				saveButtonText: translate("Salvar")
			};
			break;

		case ITypeModal.CHANGE: 
			restX.header = {
				...rest.header,
				icon: {
					name: "pencil"
				}
			};

			restX.footer = {
				...rest.footer,
				showSaveButton: true,
				saveButtonText: translate("Salvar")
			};
			break;
		
		case ITypeModal.VIEW: 
			restX.header = {
				...rest.header,
				icon: {
					name: "eye"
				}
			};

			restX.footer = {
				...rest.footer,
				showSaveButton: false,
				cancelButtonText: translate("Fechar")
			};

			break;

		case ITypeModal.COPY:
			restX.header = {
				...rest.header,
				icon: {
					name: "copy"
				}
			};

			restX.footer = {
				...rest.footer,
				showSaveButton: true,
				saveButtonText: translate("Copiar")
			};
			break;
		default:
			break;
		}
	}

	if(restX.footer){
		restX.footer = {
			...rest.footer,
			cancelButtonText: rest.footer?.showSaveButton === false ? translate("Fechar") : translate("Cancelar")
		};
	}

	return (
		<RCCModal
			ref={ref}
			footer= {{
				showSaveButton: true,
				buttonLoadingText: translate("Carregando"),
				saveButtonText: translate("Salvar"),
				cancelButtonText: translate("Cancelar")
			}}
			{...restX}
		>
			{children}
		</RCCModal>
	);
};

export default React.forwardRef(Modal);
